import { useAppSelector } from '../../../app/hooks';
import { useBlocksByCustomer } from '../../../services/entities/hooks/useBlocksByCustomer';
import { useCustomers } from '../../../services/entities/hooks/useCustomers';
import { useRanchesByCustomer } from '../../../services/entities/hooks/useRanchesByCustomer';
import { selectCurrCustomerID } from '../../select/selectSlice';

export const useGetDropdownsData = () => {
  const { customers, isCustomersLoading } = useCustomers();

  const currCustomer = useAppSelector(selectCurrCustomerID);

  const { ranches, isRanchesLoading } = useRanchesByCustomer(currCustomer);
  const { blocks, isBlocksLoading } = useBlocksByCustomer(currCustomer);

  return {
    customers,
    ranches,
    blocks,
    isCustomersLoading,
    isRanchesLoading,
    isBlocksLoading,
  };
};
